import { ClientAssets } from 'HiveClient/config/ClientAssets';

export const Loading = () => (
  <div className='tw-h-screen tw-w-screen tw-flex tw-items-center tw-justify-center'>
    <img
      src={ClientAssets.logo}
      alt='Loading...'
      className='tw-w-auto tw-max-w-[200px] tw-object-cover tw-animate-pulse'
    />
  </div>
);
